import { Card, Dialog, DialogActions, DialogContent, Fade, Icon, Modal, Slider } from "@mui/material";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import { useCallback, useState } from "react";
import Cropper from "react-easy-crop";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "95%",
  width: { xs: "80%", sm: "50%", xxl: "40%" },
  overflowY: "auto",
  p: 3,
};
// Util: recorta usando pixelCrop de react-easy-crop
const getCroppedImg = (imageSrc, pixelCrop, outputSize = 800, quality = 0.8) => {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = imageSrc;
    image.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = outputSize;
      canvas.height = outputSize; // para cuadrado
      const ctx = canvas.getContext("2d");

      // Dibujamos directamente el rectángulo que devolvió onCropComplete
      ctx.drawImage(
        image,
        pixelCrop.x,
        pixelCrop.y,
        pixelCrop.width,
        pixelCrop.height,
        0,
        0,
        outputSize,
        outputSize
      );

      canvas.toBlob(
        (blob) => {
          if (!blob) return reject(new Error("Canvas is empty"));
          resolve(blob);
        },
        "image/jpeg",
        quality
      );
    };
    image.onerror = reject;
  });
};

export default function ImageCropDialog({ open, src, onCancel, onCrop }) {
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [pixelCrop, setPixelCrop] = useState(null);

  // Aquí react-easy-crop nos devuelve la caja exacta recortada en pixeles
  const onCropComplete = useCallback((_, croppedAreaPixels) => {
    setPixelCrop(croppedAreaPixels);
  }, []);

  const handleSave = useCallback(async () => {
    try {
      if (!pixelCrop) return;
      const blob = await getCroppedImg(src, pixelCrop, 800, 0.8);
      const file = new File([blob], "cropped.jpg", { type: "image/jpeg" });
      onCrop(file);
    } catch (err) {
      console.error(err);
    }
  }, [src, pixelCrop, onCrop]);

  return (
    <Modal
      aria-labelledby="transition-modal-title"
      aria-describedby="transition-modal-description"
      open={open}
      onClose={onCancel}
      closeAfterTransition
    >
      <Fade in={open}>
        <Card sx={style}>
          <SoftBox display="flex" flexDirection="column" gap={2}>
            <SoftBox sx={{ position: "relative", width: "100%", height: 400, background: "#333" }}>
              <Cropper
                image={src}
                crop={crop}
                zoom={zoom}
                aspect={1} // relación 1:1 para cuadrado
                onCropChange={setCrop}
                onZoomChange={setZoom}
                onCropComplete={onCropComplete}
              />
            </SoftBox>
            <SoftBox sx={{ width: "100%" }} display="flex" gap={2} alignItems="center">
              <Icon color="primary" fontSize="medium">
                zoom_out
              </Icon>
              <Slider
                value={zoom}
                min={1}
                max={3}
                step={0.1}
                onChange={(_, v) => setZoom(v)}
                sx={{
                  "& .MuiSlider-track": {
                    height: 10,
                    transition: "background-image 0.5s ease-in-out",
                  },
                  "& .MuiSlider-rail": {
                    width: "100%",
                    height: 10,
                    backgroundColor: "#e9ecef",
                  },
                  "& .MuiSlider-valueLabelLabel": {
                    color: "#344767",
                  },
                }}
              />
              <Icon color="primary" fontSize="medium">
                zoom_in
              </Icon>
            </SoftBox>
            <SoftBox display="flex" justifyContent="flex-end" gap={2}>
              <SoftButton color="primary" circular onClick={onCancel}>
                Cancelar
              </SoftButton>
              <SoftButton color="uproGreen" circular onClick={handleSave}>
                Guardar
              </SoftButton>
            </SoftBox>
          </SoftBox>
        </Card>
      </Fade>
    </Modal>
  );
}
